import { useEffect } from 'react';

const GeolocationRedirect = () => {
  useEffect(() => {
    const fetchGeolocationData = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) throw new Error('Geolocation request failed');
        const data = await response.json();
        const { country_code } = data;

        if (country_code === 'CA') {
          window.location.replace('https://www.mainlogix.ca');
        }
      } catch (error) {
        console.error('Error fetching geolocation data:', error);
      }
    };

    fetchGeolocationData();
  }, []);

  return null;
};

export default GeolocationRedirect;



